import { collections } from '@/mocks/homeData';

const iconTone: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
            <i className="ri-box-3-fill" /> 精选合集
          </span>
          <h2 className="mt-2 text-2xl font-extrabold text-foreground-950 md:text-4xl">
            91免费内容包 · 按主题打包好
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            每条 91免费内容包都按主题收拢成一组，标注收录量与更新时间，浏览、收藏一次到位。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-transform hover:-translate-y-1"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl ${iconTone[item.tone]}`}
                >
                  <i className={item.icon} />
                </span>
                <span className="rounded-full bg-background-200/70 px-2.5 py-1 text-xs font-medium text-foreground-600">
                  {item.count}
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold text-foreground-950 group-hover:text-primary-700 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="whitespace-nowrap rounded-md bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="text-xs text-foreground-500">更新于 {item.update}</span>
                <a
                  href="#feed"
                  className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700"
                >
                  去浏览 <i className="ri-arrow-right-s-line" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}